import React from "react";
import { Tooltip } from "react-bootstrap";
import { useIntl } from "react-intl";
import { AEOverlayTrigger } from "../../../../_emywork/AEOverlayTrigger";
import { AERole } from "../../../../_emywork/components/AERole";
import { AESVG } from "../../../../_emywork/components/svg";

const ExtraFilter = ({
  accept,
  variant = "standard",
  onClickCallBack = () => {},
  title,
  svg,
  active = false,
}) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <AERole accept={accept}>
        <AEOverlayTrigger
          placement={"top"}
          overlay={
            <Tooltip id={`tooltip_toolbar_action`}>
              {formatMessage({ id: title })}
            </Tooltip>
          }
        >
          <div
            className={`btn btn-icon bg-light mr-3 btn-hover-icon-${variant} text-white`}
            onClick={onClickCallBack}
          >
            <AESVG path={svg} variant={active ? variant : ""} size={"2x"} />
          </div>
        </AEOverlayTrigger>
      </AERole>
    </>
  );
};

export default ExtraFilter;
